import React, {ReactNode} from 'react';
import {useHref, useLinkClickHandler} from 'react-router';
import {BreadcrumbsItem} from '@gravity-ui/uikit';

// Вспомогательный компонент для интеграции react-router и Breadcrumbs
export function RouterLink({to, children, ...rest}: {to: string; children: ReactNode}) {
  const href = useHref(to);
  const onClick = useLinkClickHandler(to);
  return (
    <BreadcrumbsItem {...rest} href={href} onClick={onClick}>
      {children}
    </BreadcrumbsItem>
  );
}
